/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type WebSettingsSmartHoldsRelayQueryVariables = {};
export type WebSettingsSmartHoldsRelayQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly orgs: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly userGoals: {
                            readonly edges: ReadonlyArray<{
                                readonly node: {
                                    readonly id: string;
                                    readonly goalId: string;
                                    readonly targetUrn: {
                                        readonly id: string;
                                        readonly type: UrnType | null;
                                        readonly value: string | null;
                                    };
                                    readonly otherUrns: ReadonlyArray<{
                                        readonly id: string;
                                        readonly type: UrnType | null;
                                        readonly value: string | null;
                                    }>;
                                    readonly name: string;
                                    readonly valueUrn: {
                                        readonly id: string;
                                        readonly type: UrnType | null;
                                        readonly value: string | null;
                                    };
                                    readonly isDeleted: boolean;
                                    readonly options: {
                                        readonly syncToGoogle: boolean;
                                        readonly specificOptions: {
                                            readonly minTimeSlot?: TimeSlot | null | undefined;
                                            readonly maxTimeSlot?: TimeSlot | null | undefined;
                                            readonly minimumDuration?: number | null | undefined;
                                            readonly idealDuration?: number | null | undefined;
                                        } | null;
                                    } | null;
                                } | null;
                            } | null> | null;
                        } | null;
                        readonly " $fragmentRefs": FragmentRefs<"WorkPreferenceGoal_org" | "SmartHoldSync_org" | "LunchGoal_org" | "TravelTimeGoal_org" | "DataSources_org">;
                    } | null;
                } | null> | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"DataSources_user">;
        } | null;
    };
};
export type WebSettingsSmartHoldsRelayQuery = {
    readonly response: WebSettingsSmartHoldsRelayQueryResponse;
    readonly variables: WebSettingsSmartHoldsRelayQueryVariables;
};



/*
query WebSettingsSmartHoldsRelayQuery {
  viewer {
    user {
      ...DataSources_user
      orgs(first: 1000000) {
        edges {
          node {
            id
            userGoals(first: 1000000) {
              edges {
                node {
                  id
                  goalId
                  targetUrn {
                    id
                    type
                    value
                  }
                  otherUrns {
                    id
                    type
                    value
                  }
                  name
                  valueUrn {
                    id
                    type
                    value
                  }
                  isDeleted
                  options {
                    syncToGoogle
                    specificOptions {
                      __typename
                      ... on GoalWithinDayOptions {
                        minTimeSlot
                        maxTimeSlot
                        minimumDuration
                        idealDuration
                      }
                    }
                  }
                }
              }
            }
            ...WorkPreferenceGoal_org
            ...SmartHoldSync_org
            ...LunchGoal_org
            ...TravelTimeGoal_org
            ...DataSources_org
          }
        }
      }
      id
    }
    id
  }
}

fragment DataSourceCreate_org on Org {
  id
  primaryOrgCalendar
}

fragment DataSource_dataSource on DataSource {
  id
  name
  calendarIds
  syncTargets {
    emailAddress
    calendarId
  }
  state
  type
  username
}

fragment DataSource_org on Org {
  id
  domains
}

fragment DataSources_org on Org {
  ...DataSource_org
  ...DataSourceCreate_org
  domains
  primaryOrgCalendar
}

fragment DataSources_user on User {
  dataSources(first: 1000000) {
    edges {
      node {
        id
        state
        type
        name
        ...DataSource_dataSource
      }
    }
  }
}

fragment LunchGoal_org on Org {
  id
  primaryOrgCalendar
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        targetUrn {
          id
          type
          value
        }
        otherUrns {
          id
          type
          value
        }
        name
        valueUrn {
          id
          type
          value
        }
        isDeleted
        options {
          syncToGoogle
          specificOptions {
            __typename
            ... on GoalWithinDayOptions {
              minTimeSlot
              maxTimeSlot
              minimumDuration
              idealDuration
            }
          }
        }
      }
    }
  }
}

fragment SmartHoldSync_org on Org {
  id
  primaryOrgCalendar
  shadowCalendarSettingsErrorable {
    __typename
    ... on ShadowCalendarSettings {
      focusTimeSyncEnabled
      lunchSyncEnabled
      travelTimeSyncEnabled
      focusTimeExternalTransparency
      focusTimeIdealMinutesPerWeek
      focusTimeSyncAll
      focusTimeRemindersEnabled
      lunchRemindersEnabled
      travelTimeRemindersEnabled
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  focusTimeStats {
    __typename
    ... on FocusTimeStats {
      minutesPerWeek
    }
  }
}

fragment TravelTimeGoal_org on Org {
  id
  ...WorkAddress_org
  workAddressForUser {
    __typename
    ... on Address {
      rawAddress
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        name
        isDeleted
        targetUrn {
          id
          type
          value
        }
        otherUrns {
          id
          type
          value
        }
        valueUrn {
          id
          type
          value
        }
        options {
          syncToGoogle
        }
      }
    }
  }
}

fragment WorkAddress_org on Org {
  id
  workAddressForUser {
    __typename
    ... on Address {
      rawAddress
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}

fragment WorkPreferenceGoal_org on Org {
  id
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        name
        isDeleted
        options {
          syncToGoogle
          specificOptions {
            __typename
            ... on GoalPreferredWorkOptions {
              preferredWorkType
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "goalId",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v4 = [
        (v1 /*: any*/),
        (v3 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
        } as any
    ], v5 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "targetUrn",
        "plural": false,
        "selections": (v4 /*: any*/),
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "otherUrns",
        "plural": true,
        "selections": (v4 /*: any*/),
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "concreteType": "Urn",
        "kind": "LinkedField",
        "name": "valueUrn",
        "plural": false,
        "selections": (v4 /*: any*/),
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isDeleted",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "syncToGoogle",
        "storageKey": null
    } as any, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minTimeSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxTimeSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minimumDuration",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "idealDuration",
                "storageKey": null
            }
        ],
        "type": "GoalWithinDayOptions",
        "abstractKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "WebSettingsSmartHoldsRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v0 /*: any*/),
                                                            "concreteType": "GoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "userGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "GoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Goal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                (v2 /*: any*/),
                                                                                (v5 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "GoalOptions",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v10 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": null,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "specificOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v11 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "userGoals(first:1000000)"
                                                        },
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "WorkPreferenceGoal_org"
                                                        },
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "SmartHoldSync_org"
                                                        },
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "LunchGoal_org"
                                                        },
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "TravelTimeGoal_org"
                                                        },
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "DataSources_org"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "DataSources_user"
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WebSettingsSmartHoldsRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "DataSourceConnection",
                                    "kind": "LinkedField",
                                    "name": "dataSources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DataSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DataSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "state",
                                                            "storageKey": null
                                                        },
                                                        (v3 /*: any*/),
                                                        (v7 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarIds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CrawlTarget",
                                                            "kind": "LinkedField",
                                                            "name": "syncTargets",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "emailAddress",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "username",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "dataSources(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v0 /*: any*/),
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": (v0 /*: any*/),
                                                            "concreteType": "GoalConnection",
                                                            "kind": "LinkedField",
                                                            "name": "userGoals",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "GoalEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Goal",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v1 /*: any*/),
                                                                                (v2 /*: any*/),
                                                                                (v5 /*: any*/),
                                                                                (v6 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v8 /*: any*/),
                                                                                (v9 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "GoalOptions",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "options",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v10 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": null,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "specificOptions",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v12 /*: any*/),
                                                                                                (v11 /*: any*/),
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "preferredWorkType",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "GoalPreferredWorkOptions",
                                                                                                    "abstractKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": "userGoals(first:1000000)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "shadowCalendarSettingsErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeSyncEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "lunchSyncEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "travelTimeSyncEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeExternalTransparency",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeIdealMinutesPerWeek",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeSyncAll",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "focusTimeRemindersEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "lunchRemindersEnabled",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "travelTimeRemindersEnabled",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "ShadowCalendarSettings",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v1 /*: any*/)
                                                                    ],
                                                                    "type": "Node",
                                                                    "abstractKey": "__isNode"
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "focusTimeStats",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "minutesPerWeek",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "FocusTimeStats",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "workAddressForUser",
                                                            "plural": false,
                                                            "selections": [
                                                                (v12 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "rawAddress",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "Address",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "message",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "statusCode",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "GraphEntityError",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                (v1 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v1 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "de0258471f064948f56148d65de9794a",
            "id": null,
            "metadata": {},
            "name": "WebSettingsSmartHoldsRelayQuery",
            "operationKind": "query",
            "text": "query WebSettingsSmartHoldsRelayQuery {\n  viewer {\n    user {\n      ...DataSources_user\n      orgs(first: 1000000) {\n        edges {\n          node {\n            id\n            userGoals(first: 1000000) {\n              edges {\n                node {\n                  id\n                  goalId\n                  targetUrn {\n                    id\n                    type\n                    value\n                  }\n                  otherUrns {\n                    id\n                    type\n                    value\n                  }\n                  name\n                  valueUrn {\n                    id\n                    type\n                    value\n                  }\n                  isDeleted\n                  options {\n                    syncToGoogle\n                    specificOptions {\n                      __typename\n                      ... on GoalWithinDayOptions {\n                        minTimeSlot\n                        maxTimeSlot\n                        minimumDuration\n                        idealDuration\n                      }\n                    }\n                  }\n                }\n              }\n            }\n            ...WorkPreferenceGoal_org\n            ...SmartHoldSync_org\n            ...LunchGoal_org\n            ...TravelTimeGoal_org\n            ...DataSources_org\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment DataSourceCreate_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment DataSource_dataSource on DataSource {\n  id\n  name\n  calendarIds\n  syncTargets {\n    emailAddress\n    calendarId\n  }\n  state\n  type\n  username\n}\n\nfragment DataSource_org on Org {\n  id\n  domains\n}\n\nfragment DataSources_org on Org {\n  ...DataSource_org\n  ...DataSourceCreate_org\n  domains\n  primaryOrgCalendar\n}\n\nfragment DataSources_user on User {\n  dataSources(first: 1000000) {\n    edges {\n      node {\n        id\n        state\n        type\n        name\n        ...DataSource_dataSource\n      }\n    }\n  }\n}\n\nfragment LunchGoal_org on Org {\n  id\n  primaryOrgCalendar\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        targetUrn {\n          id\n          type\n          value\n        }\n        otherUrns {\n          id\n          type\n          value\n        }\n        name\n        valueUrn {\n          id\n          type\n          value\n        }\n        isDeleted\n        options {\n          syncToGoogle\n          specificOptions {\n            __typename\n            ... on GoalWithinDayOptions {\n              minTimeSlot\n              maxTimeSlot\n              minimumDuration\n              idealDuration\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SmartHoldSync_org on Org {\n  id\n  primaryOrgCalendar\n  shadowCalendarSettingsErrorable {\n    __typename\n    ... on ShadowCalendarSettings {\n      focusTimeSyncEnabled\n      lunchSyncEnabled\n      travelTimeSyncEnabled\n      focusTimeExternalTransparency\n      focusTimeIdealMinutesPerWeek\n      focusTimeSyncAll\n      focusTimeRemindersEnabled\n      lunchRemindersEnabled\n      travelTimeRemindersEnabled\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  focusTimeStats {\n    __typename\n    ... on FocusTimeStats {\n      minutesPerWeek\n    }\n  }\n}\n\nfragment TravelTimeGoal_org on Org {\n  id\n  ...WorkAddress_org\n  workAddressForUser {\n    __typename\n    ... on Address {\n      rawAddress\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        name\n        isDeleted\n        targetUrn {\n          id\n          type\n          value\n        }\n        otherUrns {\n          id\n          type\n          value\n        }\n        valueUrn {\n          id\n          type\n          value\n        }\n        options {\n          syncToGoogle\n        }\n      }\n    }\n  }\n}\n\nfragment WorkAddress_org on Org {\n  id\n  workAddressForUser {\n    __typename\n    ... on Address {\n      rawAddress\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n\nfragment WorkPreferenceGoal_org on Org {\n  id\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        name\n        isDeleted\n        options {\n          syncToGoogle\n          specificOptions {\n            __typename\n            ... on GoalPreferredWorkOptions {\n              preferredWorkType\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '0586fe1fe27cb8168bb2a757a6f72def';
export default node;
